import axios from "axios";
import { initialize } from "../serviceConfig";

let token_sso;

const ensureInitialized = async () => {
  const { api_clube, token_sso: newToken } = await initialize();
  token_sso = newToken;
  return api_clube;
};

const getAxiosApi = (api) => {
  const baseURL = api.base_url;
  let axiosApi = axios.create({ baseURL });

  axiosApi.defaults.headers.common["Content-Type"] = "application/json";
  axiosApi.defaults.headers.common["client_id"] = `${api.client_id}`;
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token_sso}`;
  return axiosApi;
};

const getAds = async () => {
  const api_clube = await ensureInitialized();
  const url = `/ads/findAllAdsHome`;
  return getAxiosApi(api_clube)
    .get(url)
    .then((response) => response.data);
};

const getCategories = async () => {
  const api_clube = await ensureInitialized();
  const url = `/offers/findAllCategories`;
  return getAxiosApi(api_clube)
    .get(url)
    .then((response) => response.data);
};

const getOffersHome = async () => {
  const api_clube = await ensureInitialized();
  const url = `/offers/findAllOffersHome`;
  return getAxiosApi(api_clube)
    .get(url)
    .then((response) => response.data);
};

const getOffersByCategoryId = async (id) => {
  const api_clube = await ensureInitialized();
  const url = `/offers/findAllOffersHomeByCategoryId/${id}`;
  return getAxiosApi(api_clube)
    .get(url)
    .then((response) => response.data);
};

const getOffersById = async (id) => {
  const api_clube = await ensureInitialized();
  const url = `/offers/findById/${id}`;
  return getAxiosApi(api_clube)
    .get(url)
    .then((response) => response.data);
};

const getOffersByFilters = async (data) => {
  const api_clube = await ensureInitialized();
  const url = `/offers/findAllOffersByFilters`;
  return getAxiosApi(api_clube)
    .post(url, data)
    .then((response) => response.data);
};

export {
  getAds,
  getCategories,
  getOffersHome,
  getOffersByCategoryId,
  getOffersById,
  getOffersByFilters,
};
